module.exports = __webpack_public_path__ + "5c794c3af1d6233654025bb26fdd3daa.jpg";